export const ValueTemplateText = "{value}";
export const DebounceTime = 500;
export const DndItemType = "row";
export const DynamicFieldSuffix = "-question";
